import React from 'react';
import ReactDOM from 'react-dom';
import * as moment from 'moment';

import play from '../../assets/icons/play-54-4b7fa8b71484507993b8958a4124dcce.png';


class Audition extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { audition, handleArchiveClick } = this.props;

    return (
      <div className="amateur-audition bg-white thumbnail">
        <a className="lazy video" href={`/naked-amateur-auditions/${audition.slug}`}>
          <img alt="Xlthumb placeholder" className="img-responsive video-thumbnail" src={audition.image} style={{ opacity: 1 }} />
          <img alt="Play 54" className="play-icon" src={play} />

        </a>
        <div className="caption">
          <h3 className="caption-title"><a href={`/naked-amateur-auditions/${audition.slug}`}>{audition.title}</a></h3>
          <small className="caption-date text-muted">{moment(audition.date).format('LL')}</small>
        </div>
      </div>
    );
  }
}

export default Audition;
